(function () {
  function syncPdpRating(section) {
    var ratingText = section.getAttribute('data-review-rating-value');
    var reviewCount = Number(section.getAttribute('data-review-count'));
    var rating = Number(ratingText);
    if (!ratingText || !Number.isFinite(rating) || rating <= 0) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-review-rating]'), function (summary) {
      var stars = summary.querySelector('[data-pdp-review-stars]');
      var value = summary.querySelector('[data-pdp-review-value]');
      var count = summary.querySelector('[data-pdp-review-count]');
      if (stars) stars.style.setProperty('--dt-rating-fill', Math.min(rating, 5) * 20 + '%');
      if (value) value.textContent = ratingText;
      if (count && Number.isFinite(reviewCount) && reviewCount > 0) {
        count.textContent = '(' + reviewCount + ')';
        count.hidden = false;
      }
      summary.setAttribute('aria-label', ratingText + ' out of 5 customer rating. View reviews');
    });
  }

  function initPdpReviewLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-review-rating]'), function (link) {
      if (link.getAttribute('data-pdp-review-link-ready') === 'true') return;

      link.addEventListener('click', function (event) {
        var target = document.getElementById('product-reviews');
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
      link.setAttribute('data-pdp-review-link-ready', 'true');
    });
  }

  function visibleReviewNames(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-review-card]'))
      .filter(function (card) { return !card.hidden; })
      .map(function (card) {
        var name = card.querySelector('strong');
        return name ? name.textContent.trim() : '';
      });
  }

  function initAluveraReviewControls(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = Array.prototype.slice.call(root.querySelectorAll('#product-reviews'));

    if (root.id === 'product-reviews') {
      sections.unshift(root);
    }

    sections.forEach(function (section) {
      initAluveraReviewSection(section);
    });
  }

  function initAluveraReviewSection(section) {
    if (!section) return;
    syncPdpRating(section);
    if (section.getAttribute('data-review-controls-ready') === 'true') return;

    var searchInput = section.querySelector('.dt-pdp-ab__review-search');
    var sortSelect = section.querySelector('.dt-pdp-ab__review-sort select');
    var topicButtons = Array.prototype.slice.call(section.querySelectorAll('[data-review-topic]'));
    var list = section.querySelector('.dt-pdp-ab__review-list');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-review-card]'));
    var pagination = section.querySelector('.dt-pdp-ab__review-pagination');
    var reviewsPerPage = 5;
    var currentPage = 1;

    initReviewImageGallery(section);

    if (!sortSelect || !list || !cards.length) return;

    var empty = section.querySelector('.dt-pdp-ab__review-empty');
    if (!empty) {
      empty = document.createElement('p');
      empty.className = 'dt-pdp-ab__review-empty';
      empty.hidden = true;
      empty.textContent = 'No reviews match this filter.';
      list.after(empty);
    }

    function getActiveTopics() {
      return topicButtons
        .filter(function (button) { return button.getAttribute('aria-pressed') === 'true'; })
        .map(function (button) { return button.getAttribute('data-review-topic'); });
    }

    function pageButton(page, label, options) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.setAttribute('aria-label', options && options.label ? options.label : 'Review page ' + page);

      if (options && options.className) button.className = options.className;
      if (options && options.disabled) button.disabled = true;

      if (page === currentPage && !(options && options.arrow)) {
        button.setAttribute('aria-current', 'page');
      }

      button.addEventListener('click', function () {
        if (button.disabled || page === currentPage) return;
        currentPage = page;
        applyReviewControls(false);
      });

      return button;
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      pagination.innerHTML = '';
      pagination.hidden = totalPages <= 1;

      if (totalPages <= 1) return;

      pagination.appendChild(pageButton(
        Math.max(1, currentPage - 1),
        '‹',
        {
          arrow: true,
          className: 'dt-pdp-ab__review-page-arrow',
          disabled: currentPage === 1,
          label: 'Previous review page'
        }
      ));

      var visiblePages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages]
        .filter(function (page) { return page >= 1 && page <= totalPages; })
        .filter(function (page, index, pages) { return pages.indexOf(page) === index; })
        .sort(function (a, b) { return a - b; });

      visiblePages.forEach(function (page, index) {
        if (index > 0 && page - visiblePages[index - 1] > 1) {
          var gap = document.createElement('span');
          gap.className = 'dt-pdp-ab__review-page-gap';
          gap.setAttribute('aria-hidden', 'true');
          gap.textContent = '…';
          pagination.appendChild(gap);
        }

        pagination.appendChild(pageButton(page, String(page)));
      });

      pagination.appendChild(pageButton(
        Math.min(totalPages, currentPage + 1),
        '›',
        {
          arrow: true,
          className: 'dt-pdp-ab__review-page-arrow',
          disabled: currentPage === totalPages,
          label: 'Next review page'
        }
      ));
    }

    function applyReviewControls(resetPage) {
      if (resetPage !== false) currentPage = 1;

      var search = searchInput ? (searchInput.value || '').trim().toLowerCase() : '';
      var activeTopics = getActiveTopics();
      var filteredCards = cards.filter(function (card) {
        var cardText = card.textContent.toLowerCase();
        var cardTopics = (card.getAttribute('data-review-topics') || '').toLowerCase();
        var matchesSearch = !search || cardText.indexOf(search) !== -1 || cardTopics.indexOf(search) !== -1;
        var matchesTopics = !activeTopics.length || activeTopics.some(function (topic) {
          return cardTopics.indexOf(topic) !== -1;
        });

        return matchesSearch && matchesTopics;
      });

      filteredCards.sort(function (a, b) {
        var sortValue = sortSelect.value || 'recent';
        var dateA = new Date(a.getAttribute('data-review-date') || 0).getTime();
        var dateB = new Date(b.getAttribute('data-review-date') || 0).getTime();
        var ratingA = Number(a.getAttribute('data-review-rating') || 0);
        var ratingB = Number(b.getAttribute('data-review-rating') || 0);

        if (sortValue === 'oldest') return dateA - dateB;
        if (sortValue === 'highest') return ratingB - ratingA || dateB - dateA;
        if (sortValue === 'lowest') return ratingA - ratingB || dateB - dateA;
        return dateB - dateA;
      }).forEach(function (card) {
        list.appendChild(card);
      });

      var totalPages = Math.max(1, Math.ceil(filteredCards.length / reviewsPerPage));
      currentPage = Math.min(currentPage, totalPages);
      var pageStart = (currentPage - 1) * reviewsPerPage;
      var pageEnd = pageStart + reviewsPerPage;

      cards.forEach(function (card) {
        card.hidden = true;
      });

      filteredCards.forEach(function (card, index) {
        card.hidden = index < pageStart || index >= pageEnd;
      });

      renderPagination(filteredCards.length ? totalPages : 0);
      empty.hidden = filteredCards.length > 0;
      section.setAttribute('data-visible-review-count', String(filteredCards.length));
      section.setAttribute('data-visible-review-names', visibleReviewNames(section).join('|'));
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyReviewControls);
      searchInput.addEventListener('change', applyReviewControls);
      searchInput.addEventListener('search', applyReviewControls);
    }
    sortSelect.addEventListener('change', applyReviewControls);

    topicButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var isPressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!isPressed));
        applyReviewControls();
      });
    });

    section.setAttribute('data-review-controls-ready', 'true');
    applyReviewControls();
  }

  function initReviewImageGallery(section) {
    if (!section || section.getAttribute('data-review-gallery-ready') === 'true') return;

    var galleryTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-review-gallery-trigger]'));
    var cardTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-review-image-trigger]'));
    var triggers = galleryTriggers.length ? galleryTriggers : cardTriggers;
    var modal = section.querySelector('[data-review-image-modal]');
    var fullImage = section.querySelector('[data-review-image-full]');
    var fullVideo = section.querySelector('[data-review-video-full]');
    var thumbnailTrack = section.querySelector('[data-review-modal-thumbnails]');
    var count = section.querySelector('[data-review-image-count]');
    var caption = section.querySelector('[data-review-image-caption]');
    var captionName = section.querySelector('[data-review-image-name]');
    var captionDate = section.querySelector('[data-review-image-date]');
    var captionStars = section.querySelector('[data-review-image-stars]');
    var captionText = section.querySelector('[data-review-image-text]');
    var dialog = section.querySelector('.dt-pdp-ab__review-image-dialog');
    var closeButtons = Array.prototype.slice.call(section.querySelectorAll('[data-review-image-close]'));
    var prevButton = section.querySelector('[data-review-image-prev]');
    var nextButton = section.querySelector('[data-review-image-next]');
    var galleryOpenButton = section.querySelector('[data-review-gallery-open]');
    var activeIndex = 0;
    var lastTrigger = null;
    var lastScrollY = 0;
    var closeTimer = null;
    var slideTimer = null;
    var thumbnailButtons = [];
    var preloadedImages = {};
    var swipeStartX = null;
    var swipeStartY = null;

    if (!triggers.length || !modal || !fullImage || !fullVideo || !thumbnailTrack) return;

    if (galleryOpenButton) {
      var openerPreview = triggers[0].querySelector('img');
      if (openerPreview) {
        var openerPreviewImage = openerPreview.cloneNode(true);
        openerPreviewImage.alt = '';
        openerPreviewImage.setAttribute('aria-hidden', 'true');
        galleryOpenButton.insertBefore(openerPreviewImage, galleryOpenButton.firstChild);
      }
    }

    triggers.forEach(function (trigger, index) {
      var thumbnailButton = document.createElement('button');
      var mediaType = trigger.getAttribute('data-review-media-type') || 'image';

      thumbnailButton.type = 'button';
      thumbnailButton.className = 'dt-pdp-ab__review-modal-thumbnail';
      thumbnailButton.setAttribute('aria-label', 'Show review ' + mediaType + ' ' + (index + 1));

      Array.prototype.forEach.call(trigger.children, function (child) {
        thumbnailButton.appendChild(child.cloneNode(true));
      });

      thumbnailButton.addEventListener('click', function () {
        var direction = index === activeIndex ? null : (index > activeIndex ? 'next' : 'prev');
        changeImage(index, direction);
      });

      thumbnailTrack.appendChild(thumbnailButton);
      thumbnailButtons.push(thumbnailButton);
    });

    function preloadImage(index) {
      var preloadIndex = (index + triggers.length) % triggers.length;
      var preloadTrigger = triggers[preloadIndex];
      var preloadSrc = preloadTrigger.getAttribute('data-review-image-src') || '';

      if (!preloadSrc || preloadedImages[preloadSrc] || (preloadTrigger.getAttribute('data-review-media-type') || 'image') === 'video') return;

      preloadedImages[preloadSrc] = true;
      var image = new Image();
      image.src = preloadSrc;
    }

    function preloadAdjacentImages(index) {
      preloadImage(index - 1);
      preloadImage(index + 1);
    }

    function setImage(index) {
      activeIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[activeIndex];
      var card = trigger.closest('[data-review-card]');
      var name = card ? card.querySelector('strong') : null;
      var stars = card ? card.querySelector('.dt-pdp-ab__stars') : null;
      var text = card ? card.querySelector('p') : null;
      var date = card ? card.querySelector('time') : null;
      var mediaType = trigger.getAttribute('data-review-media-type') || 'image';
      var mediaSrc = trigger.getAttribute('data-review-image-src') || '';

      if (mediaType === 'video') {
        fullImage.hidden = true;
        fullImage.removeAttribute('src');
        fullVideo.hidden = false;
        fullVideo.src = mediaSrc;
        fullVideo.setAttribute('aria-label', trigger.getAttribute('data-review-image-alt') || 'Customer review video');
      } else {
        fullVideo.pause();
        fullVideo.hidden = true;
        fullVideo.removeAttribute('src');
        fullVideo.removeAttribute('aria-label');
        fullImage.hidden = false;
        fullImage.src = mediaSrc;
        fullImage.alt = trigger.getAttribute('data-review-image-alt') || '';
      }
      if (count) count.textContent = (activeIndex + 1) + ' / ' + triggers.length;

      thumbnailButtons.forEach(function (thumbnailButton, thumbnailIndex) {
        if (thumbnailIndex === activeIndex) {
          thumbnailButton.setAttribute('aria-current', 'true');
        } else {
          thumbnailButton.removeAttribute('aria-current');
        }
      });

      var activeThumbnail = thumbnailButtons[activeIndex];
      if (activeThumbnail && thumbnailTrack.scrollWidth > thumbnailTrack.clientWidth) {
        thumbnailTrack.scrollLeft = activeThumbnail.offsetLeft - ((thumbnailTrack.clientWidth - activeThumbnail.offsetWidth) / 2);
      }

      if (caption && captionName && captionStars && captionText) {
        captionName.textContent = name ? name.textContent.trim() : '';
        captionStars.textContent = stars ? stars.textContent.trim() : '';
        captionText.textContent = text ? text.textContent.trim() : '';
        if (captionDate) captionDate.textContent = date ? date.textContent.trim() : '';
        caption.hidden = !(captionName.textContent || captionText.textContent);
      }

      preloadAdjacentImages(activeIndex);
    }

    function changeImage(index, direction) {
      if (!direction) {
        setImage(index);
        return;
      }

      if (slideTimer) window.clearTimeout(slideTimer);
      modal.setAttribute('data-review-slide', direction);
      setImage(index);
      modal.classList.add('is-review-sliding-in');

      window.requestAnimationFrame(function () {
        modal.classList.remove('is-review-sliding-in');
      });

      slideTimer = window.setTimeout(function () {
        slideTimer = null;
        modal.removeAttribute('data-review-slide');
      }, 180);
    }

    function openGallery(index, trigger) {
      lastTrigger = trigger || triggers[index];
      lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      setImage(index);
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      modal.classList.remove('is-closing');
      if (typeof modal.showModal === 'function' && !modal.open) {
        modal.showModal();
      }
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      window.scrollTo(0, lastScrollY);
      if (dialog) {
        try {
          dialog.focus({ preventScroll: true });
        } catch (error) {
          dialog.focus();
        }
      }
      window.requestAnimationFrame(function () {
        window.scrollTo(0, lastScrollY);
      });
    }

    function finishCloseGallery() {
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      }
      modal.classList.remove('is-closing');
      fullImage.removeAttribute('src');
      fullImage.alt = '';
      fullVideo.pause();
      fullVideo.removeAttribute('src');
      fullVideo.removeAttribute('aria-label');
      fullVideo.hidden = true;
      if (caption) caption.hidden = true;
      window.scrollTo(0, lastScrollY);
      if (lastTrigger) {
        try {
          lastTrigger.focus({ preventScroll: true });
        } catch (error) {
          lastTrigger.focus();
        }
      }
      window.requestAnimationFrame(function () {
        window.scrollTo(0, lastScrollY);
      });
    }

    function closeGallery() {
      if (!modal.classList.contains('is-open') && !modal.open) return;
      if (closeTimer) return;

      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        finishCloseGallery();
      }, 180);
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openGallery(index, trigger);
      });
    });

    if (galleryTriggers.length) {
      cardTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var triggerSrc = trigger.getAttribute('data-review-image-src') || '';
          var galleryIndex = galleryTriggers.findIndex(function (galleryTrigger) {
            return galleryTrigger.getAttribute('data-review-image-src') === triggerSrc;
          });
          openGallery(galleryIndex >= 0 ? galleryIndex : 0, trigger);
        });
      });
    }

    if (galleryOpenButton) {
      galleryOpenButton.addEventListener('click', function () {
        openGallery(0, galleryOpenButton);
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeGallery);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeGallery();
    });

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeGallery();
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        changeImage(activeIndex - 1, 'prev');
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        changeImage(activeIndex + 1, 'next');
      });
    }

    if (dialog && window.PointerEvent) {
      dialog.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' || event.target.closest('button')) return;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
      });

      dialog.addEventListener('pointerup', function (event) {
        if (swipeStartX === null || swipeStartY === null) return;

        var deltaX = event.clientX - swipeStartX;
        var deltaY = event.clientY - swipeStartY;
        swipeStartX = null;
        swipeStartY = null;

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        changeImage(activeIndex + (deltaX < 0 ? 1 : -1), deltaX < 0 ? 'next' : 'prev');
      });

      dialog.addEventListener('pointercancel', function () {
        swipeStartX = null;
        swipeStartY = null;
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeGallery();
      if (event.key === 'ArrowLeft') changeImage(activeIndex - 1, 'prev');
      if (event.key === 'ArrowRight') changeImage(activeIndex + 1, 'next');
    });

    section.setAttribute('data-review-gallery-ready', 'true');
  }

  initAluveraReviewControls();
  initPdpReviewLinks();
  document.addEventListener('DOMContentLoaded', initAluveraReviewControls);
  document.addEventListener('DOMContentLoaded', initPdpReviewLinks);
  document.addEventListener('shopify:section:load', function (event) {
    initAluveraReviewControls(event.target);
  });
})();
